// extracted by mini-css-extract-plugin
module.exports = {"keywordSuggest__menu":"keywordSuggest__menu","keywordSuggest__button":"keywordSuggest__button","SuggestAPI":"SuggestAPI","seghl":"seghl"};